<template>
  <el-drawer
    title="新增弹框"
    size="50%"
    :visible.sync="drawer"
    :direction="direction"
    
    :before-close="handleClose"
  >
    <div class="addforbidTheSale">
      <div style="display: flex; align-items: center;margin-bottom: 20px;">
        <div class="inputs mr10">
          <el-input
            v-model="formData.supplierName"
            placeholder="请输入供应商名称"
            clearable
          ></el-input>
        </div>
        <div class="inputs mr10">
          <el-select
            placeholder="选择集配中心"
            v-model="formData.logisticBusinessId"
            clearable
            filterable
          >
            <el-option
              v-for="item of options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <el-button @click="searchSupplier" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button @click="onHandleBuyer">保存</el-button>
      </div>

      <div class="auto-table-flex">
        <el-table
          :data="tableData"
          height="100%"
          :border="true"
          :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
           v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column  align="center" type="selection" width="100"> </el-table-column>
          <el-table-column
            type="index"
            width="100px"
            align="center"
            label="序号"
          >
          </el-table-column>
          <el-table-column prop="title" align="center" label="供货商名称">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.title) }}
            </template>
          </el-table-column>
          <el-table-column prop="logisticBusinessName" align="center" label="集配中心">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.logisticBusinessName) }}
            </template>
          </el-table-column>
          <el-table-column prop="buyerCreatorTypeName" align="center" label="对接业务类型">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.buyerCreatorTypeName) }}
            </template>
          </el-table-column>
          <el-table-column prop="fullname" align="center" label="联系人">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.fullname) }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="联系电话">
            <template slot-scope="scope">
              {{ $empty.empty(scope.row.mobile) }}
            </template>
          </el-table-column>
          <el-table-column prop="buyerName" align="center" label="对接业务">
           
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="fy">
        <el-pagination
          type="primary"
          background
          @size-change="handleBuyerChange"
          @current-change="handleBuyerCurrentChange"
          :current-page="currentlistPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="50"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listtotal"
        >
        </el-pagination>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "addforbidTheSale",
  props: {},
  data() {
    return {
      drawer: false,
      direction: "rtl",
      formData: {
        page: 1,
        pageSize: 50,
        supplierName: "", //	string	筛选项：供应商名称
        logisticBusinessId: "", //	number	筛选项：集配中心id
      },
      loading: false,
      currentlistPage: 1,
      listtotal: 0,
      tableData: [],
      supplierId:[],
      options:[]
    };
  },
  created() {
    this.getBusinessList();
  },
  methods: {
     // 获取集配中心数据
     getBusinessList() {
      this.$api.general.businessList({is_online:1}).then((res) => {
        this.options = res.data;
      });
    },
    searchSupplier(){
      this.formData.page=1;
      this.hqlist();
    },
    onHandleBuyer(){
      if(this.supplierId.length==0){
        this.$message.success("请选择一条供应商");
        return;
      }
      this.$api.general
        .forbiddencategoryadd({supplierIds:this.supplierId})
        .then((res) => {
          this.$message.success("添加成功");
        this.handleClose();
        this.$emit('onchange',true)
        });
    },
    handleSelectionChange(val) {
      this.supplierId=val.map(el=>el.id);
    },
    hqlist() {
      this.loading = true;
      this.$api.general
        .forbiddencategorysupplierlist(this.formData)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.data;
          this.listtotal = res.data.total;
          this.loading = false;
        });
    },
    handleBuyerChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.formData.pageSize = val;
      this.hqlist();
    },
    handleBuyerCurrentChange(val) {
      this.formData.page = val;
      this.currentlistPage = val;
      this.hqlist();
    },
    getinfo() {
      this.supplierId=[];
      this.currentlistPage=1;
      Object.assign(this.$data.formData, this.$options.data().formData);
      this.searchSupplier()
      this.drawer = true;
    },
    handleClose() {
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.addforbidTheSale {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
}
</style>
